import { createSlice } from "@reduxjs/toolkit"

const selectionsSlice = createSlice({
    name: 'selection',
    initialState: {
        country: "",
        countrypcode: "",
        cause: "All",
        operation: "All",
        region: "",
        admin1: "",
        admin1pcode: "",
        highlightedAdmin1: null,
        admin2: "",
        admin2pcode: "",
        idps:"",
        round:"",
        // User-selected round to isolate figures to (e.g. from clicking a source).
        // null = no specific round → use the latest available round.
        roundFilter: null,
        maleidps: "",
        femaleidps: "",
        assessmentDate: "",
        aiagent: true,
        // Start true so the loader covers the initial regional-figure fetch.
        mapLoading: true,
        year: 2026,
        populationType: "total",
        idpMovement: false,
        idpMovementAdmin1: null,
        idpMovementDirection: "arrivals",
        loadAdmin2Data: false,
        trend: "global",
        overallIdpsTrend: [],
        selectedSummarySourceRound: null,
    },
    reducers: {
        setCountry(state, action) {
            state.country = action.payload ?? "";
        },
        setCountryPcode(state, action) {
            state.countrypcode = action.payload ?? "";
        },

        setRegion(state, action) {
            state.region = action.payload ?? "";
        },

        setCause(state, action) {
            state.cause = action.payload ?? "";
        },

        setOperation(state, action) {
            state.operation = action.payload ?? "All";
        },

        setAdmin1(state, action) {
            state.admin1 = action.payload ?? "";
        },
        setHighlightedAdmin1(state, action) {
            state.highlightedAdmin1 = action.payload ?? null;
        },
        setAdmin2(state, action) {
            state.admin2 = action.payload ?? "";
        },
        setAIagent(state, action) {
            state.aiagent = action.payload ?? "";
        },
        setMapLoading(state, action) {
            state.mapLoading = Boolean(action.payload);
        },
        setYear(state, action) {
            state.year = action.payload ?? 2026;
        },
          setTrend(state, action) {
            state.trend = action.payload ?? "global";
        },
        setidps(state, action) {
            state.idps = action.payload ?? "";
        },
        setmaleidps(state, action) {
            state.maleidps = action.payload ?? "";
        },
        setfemaleidps(state, action) {
            state.femaleidps = action.payload ?? "";
        },
        setAssessmentDate(state, action) {
            state.assessmentDate = action.payload ?? "";
        },
        setRound(state, action) {
            state.round = action.payload ?? "";
        },
        // Round to isolate figures to; null clears it (back to latest round).
        setRoundFilter(state, action) {
            const value = action.payload;
            state.roundFilter =
                value === null || value === undefined || value === ""
                    ? null
                    : Number(value);
        },
        setOverallIdpsTrend(state, action) {
            state.overallIdpsTrend = action.payload ?? [];
        },
        setAdmin1Pcode(state, action) {
            state.admin1pcode = action.payload ?? "";
        },
        // Which population metric the map figures show: "total" | "male" | "female".
        setPopulationType(state, action) {
            state.populationType = action.payload ?? "total";
        },
        setIdpMovement(state, action) {
            state.idpMovement = Boolean(action.payload);
            if (!state.idpMovement) {
                state.idpMovementAdmin1 = null;
            }
        },
        setIdpMovementAdmin1(state, action) {
            state.idpMovementAdmin1 = action.payload ?? null;
        },
        setIdpMovementDirection(state, action) {
            state.idpMovementDirection = action.payload ?? "arrivals";
        },
        setLoadAdmin2Data(state, action) {
            state.loadAdmin2Data = Boolean(action.payload);
        },
        setSelectedSummarySourceRound(state, action) {
            state.selectedSummarySourceRound = action.payload ?? null;
        },



    }
});

export const selectionsSliceActions = selectionsSlice.actions;

export default selectionsSlice;
